import { render, staticRenderFns } from "./ArticleExcellent.vue?vue&type=template&id=38c4faba&"
import script from "./ArticleExcellent.vue?vue&type=script&lang=js&"
export * from "./ArticleExcellent.vue?vue&type=script&lang=js&"
import style0 from "./ArticleExcellent.vue?vue&type=style&index=0&id=38c4faba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports